import { render, staticRenderFns } from "./AddPromotionModal.vue?vue&type=template&id=3a4fbd6c&"
import script from "./AddPromotionModal.vue?vue&type=script&lang=js&"
export * from "./AddPromotionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPromotionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports